'use client';

import { useCallback, useEffect, useState } from 'react';

import { UserV1 } from '@/shared/api';

import { isPremiumUser } from '../lib/is-premium-user';
import { isNeedOnboardingUser } from '../lib/utils';

export function useAuthState(initialUser?: UserV1 | null) {
	const [loading, setLoading] = useState(initialUser === undefined);
	const [user, setUser] = useState<UserV1 | null>(initialUser ?? null);

	const hasPremium = isPremiumUser(user);
	const isNeedOnboarding = isNeedOnboardingUser(user);

	/* Синхронизация с SSR при изменении initialUser (напр. после router.refresh) */
	useEffect(() => {
		if (initialUser !== undefined) {
			setUser(initialUser ?? null);
			setLoading(false);
		}
	}, [initialUser]);

	/* Клиентский рефетч — вызывать после логина/логаута */
	const refresh = useCallback(async () => {
		setLoading(true);
		try {
			const res = await fetch('/api/self', { credentials: 'include' });
			if (res.ok) {
				setUser(await res.json());
			} else {
				setUser(null);
			}
		} catch {
			setUser(null);
		} finally {
			setLoading(false);
		}
	}, []);

	return {
		user,
		loading,
		hasPremium,
		isAuthorized: !!user,
		isNeedOnboarding,
		refresh,
	};
}
